import { Observable } from 'rxjs';
import { CreditWallet } from '../Entities/credit-wallet.entity';
import { CreateCreditWalletInput, PurchaseCreditsInput } from './credit-wallet-management.inputs';

/**
 * ICreditWalletManagementRepository — port for superadmin write operations.
 * Declared as abstract class so Angular DI can use it as a token at runtime.
 * Implemented in Infrastructure/Repositories.
 */
export abstract class ICreditWalletManagementRepository {
  /** Load the wallet for a tenant. Returns null if the tenant has no wallet yet. */
  abstract getByTenantId(tenantId: string): Observable<CreditWallet | null>;
  /** Create a new credit wallet for a tenant. */
  abstract create(input: CreateCreditWalletInput): Observable<CreditWallet>;
  /** Add purchased credits to an existing wallet. */
  abstract purchaseCredits(input: PurchaseCreditsInput): Observable<CreditWallet>;
}
